import { Col, Row } from 'react-bootstrap';
import RadioInput from '../common/radio';

const EnableSelfUnlock = ({ values, setFieldValue, handleInputChange }) => {
  return (
    <Row className="open-enrollment-approval Payment-details section-separator-border">
      <Col md={5} lg={5} sm={5} className="padding-0">
        <h3>Enable Self‑Unlock </h3>
        <p>Select whether User can unlock his account by himself or not.</p>
      </Col>
      <Col md={2} lg={2} sm={2} className="setup-form">
        <Row className="pt-2">
          <Col>
            <RadioInput
              id="enable-self-unlock"
              label="Yes"
              name="EnableSelfUnlock"
              value={true}
              checked={values.EnableSelfUnlock === true}
              onChange={(e) => {
                setFieldValue('EnableSelfUnlock', true);
              }}
            />
          </Col>
          <Col className="approval-enroll">
            <RadioInput
              id="disable-self-unlock"
              label="No"
              name="EnableSelfUnlock"
              value={false}
              checked={values.EnableSelfUnlock === false}
              onChange={(e) => {
                setFieldValue('EnableSelfUnlock', false);
              }}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default EnableSelfUnlock;
